import { useEffect } from 'react'
import Cookies from 'js-cookie'
import { useSliceStateSelector } from 'slices/hooks'
import {
  cookieName,
  getCookieValue,
  isNewCookieConsentEnabled,
} from 'utils/cookies'

const useStoreCookieConsent = () => {
  const { cookieConsent } = useSliceStateSelector(
    (state) => state.slices.cookies
  )

  useEffect(() => {
    // If the cookie consent feature is not enabled, we should not store any cookie consent
    if (!isNewCookieConsentEnabled()) return

    // If the timestamp is set, we know that the user has made a choice and we should store it
    if (cookieConsent?.timestamp) {
      const currentCookieConsentString = getCookieValue(
        cookieName.trrCookieConsent
      )
      const newCookieConsentString = JSON.stringify(cookieConsent)
      if (currentCookieConsentString !== newCookieConsentString) {
        Cookies.set(cookieName.trrCookieConsent, newCookieConsentString, {
          expires: 365,
          secure: true,
        })
      }
    }
  }, [cookieConsent])
}

export default useStoreCookieConsent
